import './_ticket.scss';
import './_ticket.dark-mode.scss';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Panel, Row, Col, ListGroup, Grid, Badge, Button } from 'react-bootstrap';
import qs from 'qs';

import Message from './components/Message';
import TicketBody from './components/TicketBody';
import ConfirmModal from '../../../components/Modal/Confirm';
import ConfirmTemplates from './components/ConfirmTemplates';
import UserLinks from './components/UserLinks';
import Loader from '../../../components/Loaders/Loader';

import { getTicketViewSelector } from '../../../redux/selectors/tickets';
import { getTicketView, clearTicketView, setActiveTicketForView, getTicketsConfigAction } from '../../../redux/actions/tickets';
import { prepareConfirmBtnsText, deleteTicketFunc, deleteMessageFunc, closeTicketFunc, markAsSpamTicketFunc } from './helpers';
import ModalsManager from './components/Modals/Manager';
import * as actionTypes from '../../../redux/types/tickets';

const TicketsDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const queryString = qs.parse(location.search.slice(1));

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [confirmValues, setConfirmValues] = useState({
    key: null,
    title: '',
  });
  const [modal, setModal] = useState({
    openModalKey: null,
    data: {},
  });

  const onHideModals = () => {
    setModal((prevState) => ({
      ...prevState,
      openModalKey: null,
      data: {},
    }));
  };

  const onOpenModal = (openModalKey, data) => {
    setModal({
      openModalKey,
      data,
    });
  };

  const toggleConfirm = () => setIsOpenConfirm(!isOpenConfirm);

  const view = useSelector((state) => getTicketViewSelector(state));
  const { messages, title, id, locked, access, isFetching, user, replies, cdn } = view;

  const onSubmitConfirm = () => {
    const { key } = confirmValues;

    switch (key) {
    case 1:
      deleteMessageFunc(confirmValues.id, confirmValues.ticketID, setError, dispatch, toggleConfirm);
      break;

    case 2:
      toggleConfirm();
      deleteTicketFunc(dispatch, confirmValues.id, setError, history);
      break;

    case 3:
      toggleConfirm();
      closeTicketFunc(dispatch, 1, id, setError, history);
      break;

    case 4:
      toggleConfirm();
      closeTicketFunc(dispatch, 0, id, setError, history);
      break;

    case 5:
      toggleConfirm();
      markAsSpamTicketFunc(dispatch, 1, id, setError, history);
      break;

    default:
      break;
    }
  };

  const prepareConfirm = (props) => {
    setConfirmValues(props);
    toggleConfirm();
  };

  const onSubmitModal = () => {
    onHideModals();
    dispatch({
      type: actionTypes.CHANGE_TICKET_MESSAGE_SUCCESS,
      payload: {},
    });
  };

  const onBack = () => {
    if (window?.history?.state && window?.history?.state?.key !== 'default' && window?.history?.length > 1) {
      history?.goBack(-1);
    } else {
      history.push('/tickets');
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([dispatch(getTicketView(queryString.id)), dispatch(setActiveTicketForView(queryString.id)), dispatch(getTicketsConfigAction())])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));

    return () => {
      dispatch(clearTicketView());
    };
  }, [queryString.id, dispatch]);

  useEffect(() => {
    document.title = `Ticket ${id || ''}`;
  }, [location.search, id]);

  return (
    <>
      <ModalsManager modal={modal} onHide={onHideModals} onSubmit={onSubmitModal} />
      <ConfirmModal
        toggle={toggleConfirm}
        isOpen={isOpenConfirm}
        onConfirm={onSubmitConfirm}
        title={<ConfirmTemplates.Title actionKey={confirmValues.key} {...confirmValues} />}
        description={<ConfirmTemplates.Body actionKey={confirmValues.key} {...confirmValues} />}
        {...prepareConfirmBtnsText(confirmValues)}
      />

      {loading || isFetching ? (
        <Loader />
      ) : (
        <Grid fluid>
          {queryString.id && (
            <Row>
              <Col xs={12} lg={8} sm={9} className="details__col">
                <Button className="details__back-button" onClick={onBack} bsStyle="link">
                  <span>‹</span>
                  Back
                </Button>
                <Row>
                  <Col md={2} mdPush={10}>
                    <UserLinks user={user} />
                  </Col>

                  <Col md={10} mdPull={2}>
                    <Panel>
                      <Panel.Heading className="details__header">
                        <div className="details__header-title">{title}</div>
                        <div className="details__header-id">{`ID: ${id}`}</div>
                      </Panel.Heading>
                      <ListGroup>
                        <TicketBody
                          id={id}
                          globalError={error}
                          setError={setError}
                          prepareConfirm={prepareConfirm}
                          access={access}
                          replies={replies}
                          cdn={cdn}
                        />
                        <div className="list-group-item">
                          <Row>
                            {locked && (
                              <div className="text-center m-b">
                                <Badge className="details__locked">
                                  <span className="fas fa-lock" />
                                  Ticket is locked now and user not able to reply
                                </Badge>
                              </div>
                            )}
                            {messages?.map((el, i) => (
                              <Message
                                ticketID={id}
                                key={i}
                                prepareConfirm={prepareConfirm}
                                readStatus={el?.is_unread}
                                info={el}
                                onOpenModal={onOpenModal}
                              />
                            ))}
                          </Row>
                        </div>
                      </ListGroup>
                    </Panel>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Grid>
      )}
    </>
  );
};

export default TicketsDetails;
